import {Grammarly, GrammarlyProps} from '@grammarly/editor-sdk-react';
import React, {FC, PropsWithChildren} from 'react';

import {isChromeOrChromium117} from '../../../libs/shared/core/src/helpers/environment/platformHelpers';
import {
  getHasGrammarlyAutoComplete,
  getIsGrammarlyDisabledForChrome,
} from '../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {useAppSelector} from '../../helpers/appReduxHelpers';
import {getGrammarlyClientId, getGrammarlyRedirectUri} from './grammarlyConstants';
import {useGrammarlyState} from './grammarlyContext';
import {getCompanyHasGrammarlyPremium, getIsGrammarlyAllEnabled} from './grammarlySelectors';

/*
 * Components.
 */

// Until we get an type update that correctly types Grammarly, let's just cast.
const GrammarlyWithChildren = Grammarly as FC<PropsWithChildren<GrammarlyProps>>;

// Wrapper for Grammarly component should be apart of a parent where it has GrammarlyEditorPlugins/GrammarlyButtons under it
export const GrammarlyWrapper: FC<PropsWithChildren<unknown>> = (props) => {
  const {children} = props;
  const isGrammarlyAllEnabled = useAppSelector(getIsGrammarlyAllEnabled);
  const isGrammarlyAutoCompleteEnabled = useAppSelector(getHasGrammarlyAutoComplete);
  const {shouldGrammarlySuggestionOpen} = useGrammarlyState();
  const hasGrammarlyPremium = useAppSelector(getCompanyHasGrammarlyPremium);
  const isGrammarlyDisabledForChrome = useAppSelector(getIsGrammarlyDisabledForChrome);

  if (!isGrammarlyAllEnabled || (isGrammarlyDisabledForChrome && isChromeOrChromium117())) {
    return <>{children}</>;
  }
  return (
    <GrammarlyWithChildren
      clientId={getGrammarlyClientId(hasGrammarlyPremium)}
      config={{
        documentDomain: 'mail',
        toneDetector: hasGrammarlyPremium ? 'on' : 'off',
        oauthRedirectUri: getGrammarlyRedirectUri(),
        // TODO: Change 'on' to 'text' once we fix the suggestion issue
        autocomplete: isGrammarlyAutoCompleteEnabled && hasGrammarlyPremium ? 'text' : 'off',
        suggestionCards: shouldGrammarlySuggestionOpen ? 'on' : 'off',
      }}
    >
      {children}
    </GrammarlyWithChildren>
  );
};
